// extracted by mini-css-extract-plugin
module.exports = {"d2xCrowdfunding":"crowdfunding_d2xCrowdfunding__I4cvM"};